// extracted by mini-css-extract-plugin
export default {"card":"DashboardCard_card__f97l6","cardHeader":"DashboardCard_cardHeader__XXa7l","number":"DashboardCard_number__nui6X","title":"DashboardCard_title__ro4RU"};